import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class WatchfaceService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-watchfaces'] = environment.host('v2-watchfaces');
    }

    getWatchface(watchfaceId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-watchfaces']}/v2/watchfaces/${watchfaceId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.getWatchface.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.getWatchface.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getPublicWatchface(watchfaceId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-watchfaces']}/v2/watchfaces/public/${watchfaceId}`, {
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.getPublicWatchface.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.getPublicWatchface.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAdminWatchfaces(parameters: { skip?: number, max?: number, search?: string, tags?: string[], from?: number, to?: number, status?: string[], rmin?: number, rmax?: number, orderby?: string } = {}): Observable<any> {
        const params: any = {};
        if (parameters.skip != null) {
            params.skip = parameters.skip;
        }
        if (parameters.max != null) {
            params.max = parameters.max;
        }
        if (parameters.search != null) {
            params.search = parameters.search;
        }
        if (parameters.tags != null) {
            params.tags = parameters.tags.map(tag => tag.trim()).join(',');
        }
        if (parameters.from != null) {
            params.from = parameters.from;
        }
        if (parameters.to != null) {
            params.to = parameters.to;
        }
        if (parameters.status != null) {
            params.status = parameters.status.map(status => status.trim()).join(',');
        }
        if (parameters.rmin != null) {
            params.rmin = parameters.rmin;
        }
        if (parameters.rmax != null) {
            params.rmax = parameters.rmax;
        }
        if (parameters.orderby != null) {
            params.orderby = parameters.orderby;
        }
        return this.client.request('GET', `${this.host['v2-watchfaces']}/v2/watchfaces/admin/list`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            params: params
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.getAdminWatchfaces.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.getAdminWatchfaces.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    approveWatchface(watchfaceId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-watchfaces']}/v2/watchfaces/${watchfaceId}/approve`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.approveWatchface.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.approveWatchface.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    rejectWatchface(watchfaceId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-watchfaces']}/v2/watchfaces/${watchfaceId}/reject`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.rejectWatchface.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.rejectWatchface.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    approveWatchfaceWithSecret(watchfaceId: string, secret: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-watchfaces']}/v2/watchfaces/public/${watchfaceId}/approve/${secret}`, {
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.approveWatchfaceWithSecret.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.approveWatchfaceWithSecret.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    rejectWatchfaceWithSecret(watchfaceId: string, secret: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-watchfaces']}/v2/watchfaces/public/${watchfaceId}/reject/${secret}`, {
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('WatchfaceService.rejectWatchfaceWithSecret.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('WatchfaceService.rejectWatchfaceWithSecret.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
